/*
 * Add-to-order mode. The returns portal (returns.robertovinous.com) sends a
 * customer here with ?rv_add=<order id>&rv_order=<order number> so they can
 * shop for more items to put on an order that hasn't shipped yet. While the
 * mode is on: the announcement bar is swapped for a pinned one showing which
 * order they're adding to (with a countdown to when the order stops taking
 * changes, ?rv_until=<epoch s>; a cart with items in it at that moment gets
 * ?rv_extra=<s> longer to check out, an empty one just ends the mode),
 * the cart's free-shipping bar becomes "Ships with your order", the cart
 * shows what the items will cost on that order (its discount carries over;
 * the portal prices it, ?rv_token=<signed>), and the checkout button
 * becomes "Add to order #…", which hands the cart to the
 * portal (review → added to the same order → pay the difference) instead of
 * starting a new checkout. Outside the mode this script does nothing.
 */
(function () {
  var PORTAL = 'https://returns.robertovinous.com';
  try {
    // Theme dev preview only: point at a local portal for testing.
    if (location.hostname === '127.0.0.1') PORTAL = localStorage.getItem('rvAddPortal') || PORTAL;
  } catch (e) {}
  var KEY = 'rvAddToOrder';
  var EXPIRED_KEY = 'rvAddToOrderExpired';
  var TTL_MS = 2 * 60 * 60 * 1000; // without a deadline, the mode ends after 2 hours
  var SHIP_NOTE = 'Ships with your order — no extra shipping.';

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!s || !s.id || !s.name) return null;
      if (Date.now() >= hardEnd(s)) return null;
      return s;
    } catch (e) {
      return null;
    }
  }
  // When the mode is over for good: the deadline plus the finish allowance
  // (a cart in progress may still check out), or 2 hours with no deadline.
  function hardEnd(s) {
    return s.until ? s.until + (s.extra || 0) : s.at + TTL_MS;
  }
  function cartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return cart.item_count || 0; })
      .catch(function () { return 0; });
  }
  function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  // "123:2,456:1" → [{ id, quantity }]
  function parseItems(raw) {
    var out = [];
    (raw || '').split(',').forEach(function (part) {
      var m = /^(\d+):(\d{1,2})$/.exec(part);
      if (m) out.push({ id: Number(m[1]), quantity: Number(m[2]) });
    });
    return out;
  }

  var BANNER_CSS =
    // Stands in for the store's own announcement bar (same look), pinned to the top.
    '.rv-add-banner{background:#000;color:#fff;font:400 13px/1.3 Helvetica,Arial,sans-serif;' +
    'padding:7px 10px;text-align:center;position:fixed;top:0;left:0;right:0;z-index:800;' +
    'white-space:nowrap;overflow:hidden}' +
    // Phones: drop the word "order" so the line fits ("Adding to #RV1234 · …").
    '@media (max-width:480px){.rv-add-wide{display:none}}' +
    'html.rv-add-mode .header-toolbar{display:none!important}' +
    '.rv-add-banner button{background:none;border:0;color:#fff;text-decoration:underline;' +
    'cursor:pointer;font:inherit;margin-left:10px;padding:0}' +
    '.rv-add-time{white-space:nowrap}.rv-add-timer{font-variant-numeric:tabular-nums;font-weight:700}' +
    // The fixed banner sits above the page; push the page down by its height.
    'html.rv-add-mode body{padding-top:var(--rv-add-h,40px)}';

  function addStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }
  var fitBanner = function () {};
  function showBanner(build) {
    function mount() {
      var bar = document.createElement('div');
      bar.className = 'rv-add-banner';
      bar.setAttribute('role', 'status');
      build(bar);
      document.body.insertBefore(bar, document.body.firstChild);
      document.documentElement.classList.add('rv-add-mode');
      var fit = function () {
        // One row on any screen: shrink the text until it fits (wrapping
        // only as a last resort below 10px).
        bar.style.whiteSpace = '';
        var size = 13;
        bar.style.fontSize = size + 'px';
        while (bar.scrollWidth > bar.clientWidth && size > 10) {
          size -= 0.5;
          bar.style.fontSize = size + 'px';
        }
        if (bar.scrollWidth > bar.clientWidth) bar.style.whiteSpace = 'normal';
        document.documentElement.style.setProperty('--rv-add-h', bar.offsetHeight + 'px');
        // If the theme's sticky header is switched on, it sticks below the banner.
        var header = document.querySelector('.section-header');
        if (header && getComputedStyle(header).position === 'sticky') {
          header.style.top = 'calc(' + bar.offsetHeight + 'px - var(--announcement-height, 0px))';
        }
      };
      fit();
      fitBanner = fit;
      // Refit when the bar's width changes (rotation, resize) — not on the
      // height changes fit() itself causes.
      var lastWidth = bar.clientWidth;
      var refit = function () {
        if (bar.clientWidth === lastWidth) return;
        lastWidth = bar.clientWidth;
        fit();
      };
      window.addEventListener('resize', refit);
      if (window.ResizeObserver) new ResizeObserver(refit).observe(bar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
  }
  function bannerButton(text, onClick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = text;
    b.addEventListener('click', onClick);
    return b;
  }

  var params = new URLSearchParams(location.search);
  var id = params.get('rv_add');
  var name = params.get('rv_order');
  var until = params.get('rv_until');
  var extra = params.get('rv_extra');
  var token = params.get('rv_token');
  var restore = parseItems(params.get('rv_restore'));
  var entering = /^\d+$/.test(id || '') && /^[A-Za-z0-9-]{1,20}$/.test(name || '');

  if (entering) {
    save({
      id: id,
      name: name,
      at: Date.now(),
      until: /^\d{9,11}$/.test(until || '') ? Number(until) * 1000 : null,
      extra: /^\d{1,4}$/.test(extra || '') ? Number(extra) * 1000 : 0,
      token: /^\d{9,11}\.[0-9a-f]{64}$/.test(token || '') ? token : null
    });
    try { sessionStorage.removeItem(EXPIRED_KEY); } catch (e) {}
    // Keep the address bar clean (and the params out of shared links).
    ['rv_add', 'rv_order', 'rv_until', 'rv_extra', 'rv_token', 'rv_restore'].forEach(function (k) { params.delete(k); });
    var qs = params.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  // The mode ended with items still in the cart: say so once, so a normal
  // checkout (a new order) isn't a surprise. An empty cart needs no notice —
  // the store is simply back to normal.
  function showExpiredNotice(orderName) {
    if (document.querySelector('.rv-add-banner')) return;
    addStyle(BANNER_CSS);
    showBanner(function (bar) {
      bar.appendChild(document.createTextNode(
        'Time’s up — order #' + orderName + ' is being packed and can’t take more items.'
      ));
      bar.appendChild(bannerButton('Dismiss', function () {
        try { sessionStorage.removeItem(EXPIRED_KEY); } catch (e) {}
        location.reload();
      }));
    });
  }
  function endExpired(orderName, thenReload) {
    clear();
    cartCount().then(function (n) {
      if (n > 0) {
        try { sessionStorage.setItem(EXPIRED_KEY, orderName); } catch (e) {}
        if (!thenReload) showExpiredNotice(orderName);
      }
      if (thenReload) location.reload();
    });
  }

  // Deadline (plus allowance) passed between page loads.
  try {
    var stored = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (stored && stored.until && Date.now() >= hardEnd(stored)) endExpired(stored.name, false);
  } catch (e) {}

  var state = load();
  if (!state) {
    var expiredName = null;
    try { expiredName = sessionStorage.getItem(EXPIRED_KEY); } catch (e) {}
    if (expiredName) showExpiredNotice(expiredName);
    return;
  }
  var label = 'Add to order #' + state.name;

  // "Keep shopping" from the portal's review page: put the cart back.
  if (entering && restore.length) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: restore })
    }).then(function () { location.reload(); }).catch(function () {});
  }

  addStyle(
    BANNER_CSS +
    // Express checkouts would start a separate order — hide them in this mode.
    '.shopify-payment-button,.additional-checkout-buttons,shopify-accelerated-checkout,' +
    'shopify-accelerated-checkout-cart,[data-shopify="payment-button"]{display:none!important}' +
    // The free-shipping progress bar doesn't apply: these ship with the order.
    '.cart-free-shipping-bar__message,.cart-free-shipping-bar__rail{display:none!important}' +
    // "…shipping calculated at checkout" would contradict "no extra shipping".
    '.cart__taxes-policies,.cart-drawer-form__taxes-policies{display:none!important}' +
    '.rv-add-ship{font:400 13px/1.4 Helvetica,Arial,sans-serif;color:#1a1a1a;margin:0}' +
    '.rv-add-ship--button{color:#57534e;font-size:12px;margin:0 0 8px;text-align:center}' +
    // Our own totals replace the cart page's list-price subtotal — only
    // once they're actually showing.
    'html.rv-add-quoted .cart__subtotal{display:none!important}' +
    '.rv-add-summary{font:400 14px/1.5 Helvetica,Arial,sans-serif;color:#1a1a1a;margin:0 0 10px;text-align:left}' +
    '.rv-add-row{display:flex;justify-content:space-between;gap:12px}' +
    '.rv-add-row--discount{color:#2e7d32}' +
    '.rv-add-row--total{font-weight:700;font-size:16px;border-top:1px solid #e6e6e6;margin-top:6px;padding-top:6px}'
  );

  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    var two = function (n) { return (n < 10 ? '0' : '') + n; };
    return h > 0 ? h + ':' + two(m) + ':' + two(sec) : m + ':' + two(sec);
  }
  // Past the deadline with items in the cart: no countdown, just a nudge.
  var OVERTIME_TEXT = 'Check out now';
  var overtime = false;
  // "14:32 left", kept on one line; tick() refreshes the digits.
  function timeLeftEl() {
    var wrap = document.createElement('span');
    wrap.className = 'rv-add-time';
    var t = document.createElement('span');
    t.className = 'rv-add-timer';
    wrap.appendChild(t);
    if (overtime) {
      t.textContent = OVERTIME_TEXT;
    } else {
      t.textContent = fmt(state.until - Date.now());
      wrap.appendChild(document.createTextNode(' left'));
    }
    return wrap;
  }
  // The deadline just passed. Nothing in the cart → back to the normal store,
  // quietly. Items in the cart → they may still check out (the portal allows
  // the same extra time), so the mode stays on without the countdown.
  var overtimeChecked = false;
  function enterOvertime() {
    if (overtimeChecked) return;
    overtimeChecked = true;
    cartCount().then(function (n) {
      if (n === 0) {
        clear();
        location.reload();
        return;
      }
      overtime = true;
      document.querySelectorAll('.rv-add-time').forEach(function (el) {
        el.parentNode.replaceChild(timeLeftEl(), el);
      });
      fitBanner();
    });
  }
  // "… no extra shipping." plus, with a deadline, " 14:32 left"
  function shipNote(extraClass) {
    var p = document.createElement('p');
    p.className = 'rv-add-ship' + (extraClass ? ' ' + extraClass : '');
    p.appendChild(document.createTextNode(SHIP_NOTE));
    if (state.until) {
      p.appendChild(document.createTextNode(' '));
      p.appendChild(timeLeftEl());
    }
    return p;
  }

  // What the cart will cost on this order — priced by the portal, because the
  // original order's discount carries over to added items.
  var quote = null; // { key, data } for the cart contents it was priced for
  function money(n, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(n);
    } catch (e) {
      return '$' + Number(n).toFixed(2);
    }
  }
  function summaryEl() {
    var d = quote.data;
    var box = document.createElement('div');
    box.className = 'rv-add-summary';
    box.dataset.key = quote.key;
    var row = function (label, value, cls) {
      var r = document.createElement('div');
      r.className = 'rv-add-row' + (cls ? ' ' + cls : '');
      var l = document.createElement('span');
      l.textContent = label;
      var v = document.createElement('span');
      v.textContent = value;
      r.appendChild(l);
      r.appendChild(v);
      box.appendChild(r);
    };
    row('Subtotal', money(d.itemsTotal, d.currency));
    if (d.discount > 0) {
      var codes = (d.discountCodes || []).join(', ').toUpperCase();
      row('Your order discount' + (codes ? ' (' + codes + ')' : ''), '−' + money(d.discount, d.currency), 'rv-add-row--discount');
    }
    row('Shipping', 'Free');
    if (d.tax > 0) row('Tax', money(d.tax, d.currency));
    row('Total', money(d.total, d.currency), 'rv-add-row--total');
    return box;
  }
  var quoteTimer = null;
  function refreshQuote() {
    if (!state.token) return;
    clearTimeout(quoteTimer);
    quoteTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var key = (cart.items || []).map(function (i) { return i.variant_id + ':' + Math.min(i.quantity, 10); }).join(',');
          if (!key) { quote = null; decorate(); return; }
          if (quote && quote.key === key) return;
          return fetch(PORTAL + '/api/add-quote?order=' + state.id + '&token=' + state.token + '&items=' + encodeURIComponent(key))
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (data) {
              quote = data && typeof data.total === 'number' ? { key: key, data: data } : null;
              decorate();
            });
        })
        .catch(function () {});
    }, 250);
  }
  // Re-price whenever the cart changes (the theme talks to /cart/*.js).
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  if (typeof window.fetch === 'function') {
    var plainFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var result = plainFetch.apply(this, arguments);
      if (CART_CHANGE.test(url)) result.then(refreshQuote, refreshQuote);
      return result;
    };
  }
  if (typeof window.XMLHttpRequest === 'function') {
    var plainOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (typeof url === 'string' && CART_CHANGE.test(url)) this.addEventListener('loadend', refreshQuote);
      } catch (e) {}
      return plainOpen.apply(this, arguments);
    };
  }

  // The cart drawer re-renders on every cart change, so re-apply on mutation.
  function decorate() {
    document.documentElement.classList.toggle('rv-add-quoted', !!quote);
    document.querySelectorAll('[data-cart-free-shipping-bar]').forEach(function (bar) {
      if (!bar.querySelector('.rv-add-ship')) bar.appendChild(shipNote());
    });
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      if (btn.dataset.rvAdd !== label) {
        btn.dataset.rvAdd = label;
        btn.textContent = label;
      }
      // Carts without the bar on top (the cart page) get the note by the button.
      var holder = btn.parentNode;
      var scope = btn.closest('[data-component="flyout"], .cart-drawer');
      var hasBar = scope && scope.querySelector('[data-cart-free-shipping-bar]');
      if (holder && !hasBar && !holder.querySelector('.rv-add-ship')) {
        holder.insertBefore(shipNote('rv-add-ship--button'), btn);
      }
      // Totals for this order (subtotal, carried-over discount, total).
      if (holder) {
        var shown = holder.querySelector('.rv-add-summary');
        if (shown && (!quote || shown.dataset.key !== quote.key)) {
          holder.removeChild(shown);
          shown = null;
        }
        if (quote && !shown) holder.insertBefore(summaryEl(), holder.firstChild);
      }
    });
  }

  var ended = false;
  function tick() {
    if (ended) return;
    if (Date.now() >= hardEnd(state)) {
      ended = true;
      endExpired(state.name, true);
      return;
    }
    var left = state.until - Date.now();
    if (left <= 0) {
      enterOvertime();
      return;
    }
    var text = fmt(left);
    document.querySelectorAll('.rv-add-timer').forEach(function (t) {
      if (t.textContent !== text) t.textContent = text;
    });
  }

  var handingOff = false;
  function handOff() {
    if (handingOff) return;
    handingOff = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return i.variant_id + ':' + Math.min(i.quantity, 10); });
        if (!items.length) {
          handingOff = false;
          alert('Your cart is empty — add something first.');
          return;
        }
        var url = PORTAL + '/orders/' + state.id + '/add-items?items=' + encodeURIComponent(items.join(','));
        // The items travel in the link; empty the cart so they can't also be
        // checked out as a second order. (The portal's "Keep shopping" link
        // restores it.)
        clear();
        return fetch('/cart/clear.js', { method: 'POST' })
          .catch(function () {})
          .then(function () { location.href = url; });
      })
      .catch(function () {
        handingOff = false;
        alert('Something went wrong — please try again.');
      });
  }

  function isCheckoutTrigger(el) {
    return el && el.closest && el.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
  }
  document.addEventListener('click', function (e) {
    if (!isCheckoutTrigger(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handOff();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!e.submitter || e.submitter.name !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handOff();
  }, true);

  showBanner(function (bar) {
    bar.appendChild(document.createTextNode('Adding to '));
    var wide = document.createElement('span');
    wide.className = 'rv-add-wide';
    wide.textContent = 'order ';
    bar.appendChild(wide);
    bar.appendChild(document.createTextNode('#' + state.name + ' · No extra shipping fees'));
    if (state.until) {
      bar.appendChild(document.createTextNode(' · '));
      bar.appendChild(timeLeftEl());
    }
    bar.appendChild(bannerButton('Cancel', function () { clear(); location.reload(); }));
  });

  function start() {
    decorate();
    refreshQuote();
    new MutationObserver(decorate).observe(document.body, { childList: true, subtree: true });
    if (state.until) {
      if (Date.now() >= state.until) enterOvertime();
      setInterval(tick, 1000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
